import React from 'react';
import badgeNotificationStyles from './BadgeNotification.scss';
var BadgeNotificationIcon = function (_a) {
    var name = _a.name, imgSrc = _a.imgSrc;
    return (React.createElement("div", { className: badgeNotificationStyles['icon-wrap'] },
        React.createElement("img", { alt: name, className: badgeNotificationStyles['icon'], src: imgSrc })));
};
BadgeNotificationIcon.displayName = 'BadgeNotificationIcon';
export default BadgeNotificationIcon;
//# sourceMappingURL=BadgeNotificationIcon.js.map